//loyaltyPerPaymentMethodReportController
(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('loyaltyPerPaymentMethodReportController', loyaltyPerPaymentMethodReportController);

  /** @ngInject */
  function loyaltyPerPaymentMethodReportController ($scope, $translate, reportExportUtil, exportToCsv, LoyaltyPerPaymentMethodReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new LoyaltyPerPaymentMethodReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DATE'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.DATE,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('LOYALTY_PER_PAYMENT_METHOD'),
          true);
    }


  }
})();
